import React, { useEffect } from 'react'
import { RootReducer } from '../../redux/rootReducer'
import i18next from 'i18next'
import { useSelector } from 'react-redux'

const LanguageSelector = (): JSX.Element => {
  const defaultLang = useSelector((state: RootReducer) => state.userDataReducer.default_language_code)
  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    i18next.changeLanguage(defaultLang)
  }, [defaultLang])
  return <></>
}

export default LanguageSelector
